export default {
  addNew: "Add new",
  dialog: {
    editMaterial: "Edit boardmeeting material",
    addMaterial: "Add boardmeeting material",
  },
  list: {
    headers: {
      id: "ID",
      material: "Material",
    },
  },
  elementType: {
    template: "Template",
    report: "Report",
    presentation: "Presentation",
    workbook: "Workbook",
    article: "Article",
  },
  materialType: {
    template: "Template",
    report: "Report",
    presentation: "Presentation",
    workbook: "Workbook",
    article: "Article",
  },
  element: {
    form: {
      material: "Related material",
      image: "Image",
      add: "Add boardmeeting material",
      edit: "Edit boardmeeting material",
      name: "Name",
      description: "Description",
      main: "Featured",
      forCeo: "For CEO",
      type: "Type",
      file: "File",
      addAuthor: "Add author",
      authors: "Authors",
      background: "Background",
      image_horizontal: "Horizontal cover",
    },
  },
  slide: {
    form: {
      name: "Name",
      description: "Description",
      image: "Image",
      file: "File",
      element: "Related material",
      editSlide: "Edit slide",
      addSlide: "Add slide",
    },
  },
  slides: {
    list: {
      headers: {
        id: "ID",
        name: "Name",
        description: "Description",
        type: "Type",
        series: "Series",
        image: "Image",
        file: "File",
        element: "Related material",
      },
    },
  },
};
